import { useAppEnvironmentMode } from '@/features/environment/useAppEnvironmentMode.js'
import { TenantType } from '@/features/organization/organizationTypeName.js'
import { usePermissionItemFilter } from '@/features/permissions/filterPermissionItems.js'
import { PermissionActions } from '@/features/permissions/permissionActions.js'
import { useActiveClub } from '@/features/router/useActiveClub.js'

export function createAdminSidebarMenuLinkItems({ canShowTenantManagementLinks = false } = {}) {
  return [
    {
      label: 'sidebar.dashboard',
      icon: 'dashboard',
      to: '/admin/dashboard',
      permissionAction: PermissionActions.DashboardView,
    },
    {
      label: 'sidebar.people',
      icon: 'people',
      to: '/admin/people',
      permissionAction: PermissionActions.PeopleView,
      /*
      children: [
        {
          label: 'sidebar.members',
          to: '/admin/dummy',
        },
        {
          label: 'sidebar.contacts',
          to: '/admin/people/contacts',
        },
        {
          label: 'sidebar.groups',
          to: '/admin/people/groups',
        },
      ],
       */
    },
    /*
    {
      label: 'sidebar.groups',
      icon: 'groups',
    },

    {
      label: 'sidebar.fees',
      icon: 'fees',
    },
    */
    {
      label: 'sidebar.mailer',
      icon: 'mailer',
      to: '/admin/mailer',
      permissionAction: PermissionActions.MailerView,
    },
    {
      label: 'sidebar.notifications',
      iconClass: 'pi pi-bell',
      to: '/admin/notifications',
      permissionAction: PermissionActions.NoticesView,
      children: [
        {
          label: 'Send an announcement',
          to: '/admin/notifications/create',
          iconClass: 'pi pi-bell',
          permissionAction: PermissionActions.NoticesCreate,
        },
      ],
    },
    {
      label: 'sidebar.events',
      icon: 'events',
      to: '/admin/events',
      permissionAction: PermissionActions.EventsView,
      children: [
        {
          label: 'Holiday Programme',
          to: '/admin/events/holiday-programme',
          permissionAction: PermissionActions.EventsHolidayProgrammeView,
        },
        {
          label: 'Class Attendance',
          to: '/admin/events/class-attendance',
          permissionAction: PermissionActions.EventsClassAttendanceView,
        },
        {
          label: 'Committee Meetings',
          to: '/admin/events/committee-meetings',
          permissionAction: PermissionActions.EventsCommitteeMeetingsView,
        },
      ],
    },
    /*
    {
      label: 'sidebar.bookings',
      icon: 'bookings',
    },
    {
      label: 'sidebar.venues',
      icon: 'venues',
    },
    {
      label: 'sidebar.competitions',
      icon: 'competitions',
    },
    {
      label: 'sidebar.resources',
      icon: 'resources',
    },
    {
      label: 'sidebar.merchandise',
      icon: 'merchandise',
    },
    {
      label: 'sidebar.reports',
      icon: 'reports',
    },
       */
    {
      label: 'sidebar.tracking',
      icon: 'awards',
      to: '/admin/tracking',
      permissionAction: PermissionActions.TrackingView,
    },
    {
      label: 'sidebar.website',
      iconClass: 'pi pi-globe',
      to: '/admin/site-list',
      permissionAction: PermissionActions.SitesView,
    },
    canShowTenantManagementLinks && {
      label: 'Codes',
      to: '/admin/codes',
      iconClass: 'pi pi-tags',
      permissionAction: PermissionActions.CodesView,
    },
    canShowTenantManagementLinks && {
      label: 'Groups',
      to: '/admin/groups',
      iconClass: 'pi pi-users',
      permissionAction: PermissionActions.GroupsView,
    },
    canShowTenantManagementLinks && {
      label: 'Terms',
      to: '/admin/terms',
      iconClass: 'pi pi-calendar',
      permissionAction: PermissionActions.TermsView,
    },
    canShowTenantManagementLinks && {
      label: 'Term Groups',
      to: '/admin/term-groups',
      iconClass: 'pi pi-sitemap',
      permissionAction: PermissionActions.TermGroupsView,
    },
    {
      label: 'Mobile App',
      to: '/admin/mobile-app-management',
      iconClass: 'pi pi-mobile',
      permissionAction: PermissionActions.MobileAppView,
      children: [
        {
          label: 'Mobile App Users',
          to: '/admin/mobile-app-management/reports',
          iconClass: 'pi pi-users',
          permissionAction: PermissionActions.MobileAppUsersReportView,
        },
        {
          label: 'Chat reports',
          to: '/admin/mobile-app-management/chat-reports',
          iconClass: 'pi pi-cog',
          permissionAction: PermissionActions.MobileAppChatReportsView,
        },
      ],
    },
    {
      label: 'sidebar.settings',
      icon: 'settings',
      to: '/admin/settings',
      permissionAction: PermissionActions.SettingsView,
    },
  ].filter(Boolean)
}

export function useAdminSidebarMenuLinks() {
  const { activeClub } = useActiveClub()
  const { isUat2Mode } = useAppEnvironmentMode()
  const { filterItems } = usePermissionItemFilter('admin-sidebar')
  const isNormalClub = activeClub?.tenantType === TenantType.Club
  const canShowTenantManagementLinks = isNormalClub && isUat2Mode

  const sidebarItemsConfig = createAdminSidebarMenuLinkItems({
    canShowTenantManagementLinks,
  })

  return filterItems(sidebarItemsConfig)
}
